import {ApplicationStoreType} from 'reducers';
import {ReorderType} from 'features/reorder/reducers/reorder/reorderType';
import {createSelector} from 'reselect';
import {QuoteItemV2Type} from 'constants/flow/flowTypesCart';
import {FULFILLED} from 'redux-promise-middleware';
import {isCustomerLogged} from 'selectors/customer/customer';

/**
 * returns reorder from store
 * @param {ApplicationStoreType} store - redux store
 * @return {ReorderType} - reorder
 */
export const getReorder = (store: ApplicationStoreType): ReorderType => store.reorder;

/**
 * it returns reorder status
 * @param {ApplicationStoreType} store - redux store
 * @return {string} - status
 */
export const getReorderStatus = (store: ApplicationStoreType): string => store.reorder.status;

/**
 * it returns reorder checkbox value from store
 */
export const getReorderCheckboxValue = createSelector(getReorder, (reorder): boolean =>
    reorder.reorder ? reorder.reorder.reorder_checkbox_value : Boolean(reorder.reorder),
);

/**
 * returns reorder item from store
 * @param {ApplicationStoreType} store - redux store
 * @return {QuoteItemV2Type} - object of reorder item
 */
export const getReorderItem = (store: ApplicationStoreType): QuoteItemV2Type | null =>
    store.reorder.item;

/**
 * it returns reorder token
 */
export const getReorderToken = createSelector(getReorder, (reorder): string =>
    reorder.reorder ? reorder.reorder.reorder_token : '',
);

/**
 * Provides availability to show reorder info
 * @returns {boolean} flag
 */
export const isReorderAvailable = createSelector(
    getReorder,
    reorder => reorder.status === FULFILLED,
);

/**
 * returns recognized user status for analytics
 */
export const getCustomerStatus = createSelector(isCustomerLogged, (isCustomerLoggedIn):
    | 'Signed'
    | 'Cookie' => (isCustomerLoggedIn ? 'Signed' : 'Cookie'));

/**
 * it returns true if user has previous order contact lenses false otherwise
 * @param {ApplicationStoreType} store - redux store
 * @return {boolean} - true if user has CL in previous order
 */
export const hasUserPreviousOrderCl = createSelector(getReorderItem, getReorder, (item, reorder) =>
    Boolean(item && reorder.status === FULFILLED),
);
